document.addEventListener('DOMContentLoaded', function() {

  $('#modalAddToCartProduct').on('shown.bs.modal', function () {
    const productTitle = document.querySelector('#modalAddToCartProduct .tt-modal-product .tt-title-js')?.textContent.trim();

    const rightCol = document.querySelector('#modalAddToCartProduct .col-12.col-lg-6:nth-child(2)');

    if (rightCol && productTitle) {
      const isPreorder = rightCol.dataset.preorder === 'true'; 
      if (isPreorder) {
        // Crée le message
        const msg = document.createElement('div');
        msg.className = 'preorder-popup-message';
        msg.innerHTML = `
          <strong>Précommande</strong><br>
          Cet article n'est pas en stock<br>
          Il sera expédié dès sa disponibilité.<br>
          <a href="/policies/shipping-policy">En savoir plus</a>
        `;
        rightCol.insertBefore(msg, rightCol.firstChild);
      }
    }
  });

});
